module.exports = __webpack_public_path__ + "img/17-4-en.3863907f.png";